export { default } from './BlogDescricao';
